import { Link, useParams } from "react-router-dom";
import clsx from "clsx";
import { formatDateMonth } from "@helpers";
import { feTagsFlat } from "@helpers/constants";
import * as styles from "./styles";
import { tag as tagStyle } from "../Blue/styles";
import ScaleOnHoverDiv from "../../ScaleOnHoverDiv";

export default function GreenCard(props) {
    // If pre-existing id, need to ensure there's no
    // double nesting by using <a/> instead of <Link/>
    const { id } = useParams();

    const link = props.uri ? "/news/" + props.uri : props.link;
    const subheader = props.subheader || props.summary;
    const date = props.date || props.publish_date;
    const img = props.img || props.image_url;

    const CardBody = () => (
        <>
            <div className={styles.imgContainer}>
                <img
                    src={img}
                    alt={props.imgAlt}
                    className="min-h-full min-w-full object-cover"
                    loading="lazy"
                />
            </div>
            <div className={clsx(styles.textContainer, props.bg)}>
                {date && (
                    <div className={styles.date}>{formatDateMonth(date)}</div>
                )}
                <div className="line-clamp-2 text-xl font-bold">
                    {props.title}
                </div>
                <div
                    className={clsx(
                        styles.subheader +
                            (props.date ? " line-clamp-2" : " line-clamp-3"),
                    )}
                >
                    {subheader}
                </div>
                <div className={styles.linkText}>{props.linkDisplayText}</div>
                {props.children}
            </div>
            {props.tags && (
                <div className={styles.tags}>
                    {props.tags.map((tag, i) => (
                        <div className={tagStyle} key={i}>
                            {feTagsFlat[tag]}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
    return (
        <ScaleOnHoverDiv className={styles.parentContainer}>
            {id ? (
                <a href={link} className={styles.linkContainer}>
                    <CardBody />
                </a>
            ) : (
                <Link to={link} className={styles.linkContainer}>
                    <CardBody />
                </Link>
            )}
        </ScaleOnHoverDiv>
    );
}
